import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div>
                 <NavLink to='/category/Interview question/6'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/4'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<td>

<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Time and Work</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />
<p class="pq">1) Worker A completes a task in 8 days, and worker B completes the same task in 10 days. If both A and B work together, in how many days they will complete the task?</p>
<ol class="pointsu">
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work22.png" alt="Apti Time and work 22"/></span>days.</li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work23.png" alt="Apti Time and work 23"/></span>days.</li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work24.png" alt="Apti Time and work 24"/></span>days.</li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work25.png" alt="Apti Time and work 25"/></span>days.</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>Worker A completes the task in 8 days. So, in one day, he will complete<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work26.png" alt="Apti Time and work 26"/></span>part of the task.</p>
<p>So, A's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work26.png" alt="Apti Time and work 26"/></span></p> 
<p>Similarly, B's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work27.png" alt="Apti Time and work 27"/></span></p> 
<p>∴ (A+B)'s one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work28.png" alt="Apti Time and work 28"/></span></p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work29.png" alt="Apti Time and work 29"/></span>of the task is completed in one day so both will complete the whole task in<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work30.png" alt="Apti Time and work 30"/></span><sup>days</sup></p> 
</div> </Collapsible>
<br />
<p class="pq">2) Vikas and Mohan working together can complete a work in 6 days. If Vikas alone completes the same work in 10 days, in how many days Mohan alone can complete the same work?</p>
<ol class="pointsu">
<li className='list'>13 days</li>                                                    
<li className='list'>14 days</li>
<li className='list'>15 days</li>                                                    
<li className='list'>16 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>Vikas and Mohan together can complete the task in 6 days. So, in one day, they will complete <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work31.png" alt="Apti Time and work 31"/></span>part of the task.</p>
<p>Therefore, (Vikas + Mohan)'s one day work will be =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work32.png" alt="Apti Time and work 32"/></span></p> 
<p>Similarly, Vikas's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work33.png" alt="Apti Time and work 33"/></span></p>
<p>Therefore, Mohan's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work34.png" alt="Apti Time and work 34"/></span></p>
<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work35.png" alt="Apti Time and work 35"/></span>
<p>In one day Mohan completes the <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work36.png" alt="Apti Time and work 36"/></span>part of the work so he will complete the entire work in 15 days.</p>
</div> </Collapsible>
<br />
<p class="pq">3) A can do a work in 10 days and B can do the same work in 15 days.  If they start working together but stop working after four days, find the fraction of the work that is left.</p>
<ol class="pointsu">
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work37.png" alt="Apti Time and work 37"/></span></li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work38.png" alt="Apti Time and work 38"/></span></li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work39.png" alt="Apti Time and work
39"/></span></li>
<li className='list'><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work40.png" alt="Apti Time and work40"/></span></li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work41.png" alt="Apti Time and work 41"/></span></p>
<p>B's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work42.png" alt="Apti Time and work 42"/></span></p> 
<p>(A + B)'s one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work43.png" alt="Apti Time and work 43"/></span></p>
<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work44.png" alt="Apti Time and work 44"/></span>
<p>A and B's four day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work45.png" alt="Apti Time and work 45"/></span></p>
<p>Therefore,the remaining work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work46.png" alt="Apti Time and work 46"/></span></p>
</div> </Collapsible>
<br />
<p class="pq">4) Peter is twice as good as workman as Tom. When they work together they can finish a task in 16 days. If Tom works alone, in many days he will complete the task?</p>
<ol class="pointsu">
<li className='list'>46 days</li>                                          
<li className='list'>48 days</li>
<li className='list'>50 days</li>                                         
<li className='list'>52 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer' trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>(Peter + Tom)'s one-day work = 1/16</p>
<p>As per the question, Peter can finish twice as much work as finished by Tom in a given duration of time.</p>
<p>Therefore,<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work47.png" alt="Apti Time and work 47"/></span>of their one day's work will be completed by Peter and <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work48.png" alt="Apti Time and work 48"/></span> of their one day work will be completed by Tom.</p>
<p>So, Tom's one day work will be = <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work49.png" alt="Apti Time and work 49"/></span></p>
<p>So, Tom will take 48 days to complete the task.</p>
</div> </Collapsible>
<br />
<p class="pq">5) A can do a job in 12 days and B can do the same job in 10 days. With the help of C they can do the same job in 4 days. In how many days C alone can do this job?</p>
<ol class="pointsu">
<li className='list'>15 days</li>                                                
<li className='list'>14 days</li>
<li className='list'>13 days</li>                                                 
<li className='list'>12 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work50.png" alt="Apti Time and work 50"/></span></p>
<p>B's one day work = <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work51.png" alt="Apti Time and work 51"/></span></p>
<p>(A+B+C)'s one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work52.png" alt="Apti Time and work 52"/></span></p> 
<p>Therefore, C's one day work = (A+B+C)'s one day work   (A+B)'s one day work</p>
<p>So, C's one day work =<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work53.png" alt="Apti Time and work 53"/></span></p>
<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work54.png" alt="Apti Time and work 54"/></span>
<span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work55.png" alt="Apti Time and work 55"/></span>
<p>So, C will complete the work in 15 days.</p>
</div> </Collapsible>
<br />
<br/>

<p class="pq">6) A, B, C can do a job in 10, 20 and 40 days respectively. In how many days A can complete the job if he is assisted by B and C on every third day?</p>
<ol class="pointsu">
<li className='list'>8 days</li>                                                  
<li className='list'>7 days</li>
<li className='list'>9 days</li>                                                   
<li className='list'>6 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
 <div class="testanswer" id="answer1">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work56.png" alt="Apti Time and work 56"/></p>
<p>B's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work57.png" alt="Apti Time and work 57"/></p> 
<p>C's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work58.png" alt="Apti Time and work 58"/></p> 
<p>(A+B+C)'s one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work59.png" alt="Apti Time and work 59"/></p>  
<p>Work done in three days will be the sum of A's two-day work and (A+B+C)'s one day work.</p>
<p>A's two-day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work60.png" alt="Apti Time and work 60"/></p>   
<p>Therefore, the work is done in three days =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work61.png" alt="Apti Time and work 61"/>
</p><p>3/8 part of the job is done in 3 days.</p>  
<p>The entire job will be done by A in = 3 x <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work62.png" alt="Apti Time and work 62"/></p>   
</div> </Collapsible>
<br />
<p class="pq">7) If 5 men can colour 50-meter long cloth in 5 days, in many days 4 men can color a 40-meter long cloth?</p>
<ol class="pointsu">
<li className='list'>5 days</li>
<li className='list'>6 days</li>
<li className='list'>4 days</li>
<li className='list'>3 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
 <div class="testanswer" id="answer2">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>5 men colour 50-meter long cloth in 5 days.</p>
<p>1 man will colour<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work63.png" alt="Apti Time and work 63"/>= 10-meter long cloth in five days.</p>
<p>So, in one day one man can colour<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work64.png" alt="Apti Time and work 64"/>= 2-meter long cloth.</p> 
<p>Now, as per question 4 men are supposed to colour the 40-meter long cloth.</p>
<p>One man has to colour the <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work65.png" alt="Apti Time and work 65"/>= 10 meter cloth</p>
<p>For 2-meter long cloth one man takes 1 day</p>
<p>So, to paint 10-meter long cloth he will take =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work66.png" alt="Apti Time and work 66"/></p> 
<p>As, 4 men are working together so 40 m long cloth will be coloured in 5 days </p>
<p><strong>Quicker method:</strong></p>
<p><strong>Apply formula:</strong> M1D1W2 = M2D2W1</p>
<p>5*5*40 = 4*D2*50</p>
<p>D2=<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work67.png" alt="Apti Time and work 67"/></p>
</div> </Collapsible>
<br />
<p class="pq">8) If 4 men can finish 4 times of a  work in 4 days, in how many days 6 men can finish the 6 times of same work ?</p>
<ol class="pointsu">
<li className='list'>3 days</li>                                 
<li className='list'>4 days</li>
<li className='list'>5 days</li>                                 
<li className='list'>6 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
 <div class="testanswer" id="answer3">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>4 men can finish 4 times of work in four days.</p>
<p>Therefore, one man can finish the one time of work in four days.</p>
<p>So, 6 men will finish the six times of work in the same time (4 days)</p>
<p><strong>Quicker method:</strong></p> 
<p><strong>Apply formula:</strong> M1D1W2 = M2D2W1</p> 
<p>Let the work be X</p>
<p>Work done by 4 men, W1 = 4X</p>
<p>Work done by 6 men, W2 = 6X</p>
<p>4*4*6X = 6*D2*4X</p>
<p>96X = D2 *24X</p>
<p>D2= 4 days </p>
</div> </Collapsible>
<br />
<p class="pq">9)  A can do a piece of work in 10 days. B is 50% more efficient than A. In how many days B alone can do the same job?</p>
<ol class="pointsu">
<li className='list'>6.2 days</li>                                                  
<li className='list'>6.6 days</li>
<li className='list'>7 days</li>                                                      
<li className='list'>7.2 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer' trigger='Show Answer'> 
<div id="workspace4"></div>
 <div class="testanswer" id="answer4">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>B is 50%<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work68.png" alt="Apti Time and work 68"/>more efficient than A so he will take less time to do a piece of work.</p>
<p>Therefore, the ratio of the time taken by A and B =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work69.png" alt="Apti Time and work 69"/></p> 
<p>Let B takes X days to do the job.</p>
<p><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work70.png" alt="Apti Time and work 70"/></p>
<p>3X =20</p>
<p>X = 6.6 days </p>
</div> </Collapsible>
<br />
<p class="pq">10) A can do a job in 30 days. B alone can do the same job in 20 days. If A starts the work and joined by B after 10 days, in how many days the job will be done?</p>
<ol class="pointsu">
<li className='list'>15 days</li>                                               
<li className='list'>16 days</li>
<li className='list'>17 days</li>                                               
<li className='list'>18 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
 <div class="testanswer" id="answer5">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p>
<p>A's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work71.png" alt="Apti Time and work 71"/></p>
<p>A's ten-day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work72.png" alt="Apti Time and work 72"/></p>
<p>So the remaining work would be =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work73.png" alt="Apti Time and work 73"/></p> 
<p>B's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work74.png" alt="Apti Time and work 74"/></p>  
<p>A and B's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work75.png" alt="Apti Time and work 75"/></p>   
<p><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work76.png" alt="Apti Time and work 76"/>of the job will be done by them in one day.</p>
<p>So, the remaining job<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work77.png" alt="Apti Time and work 77"/>= 8 days</p>   
<p>Therefore, the total number of days required to do the job would be = 10 + 8 = 18 days</p>
</div> </Collapsible>
<br />

<br/>


<p class="pq">11) A can do a piece of work in 6 days working 8 hours a day. B can do the same work in 4 days working 6 hours a day. If they work together 8 hours a day, in how many days they will do this work?</p>
<ol class="pointsu">
<li className='list'>3 days</li>                                                         
<li className='list'>3.5 days</li> 
<li className='list'>2 days</li>                                                         
<li className='list'>2.5 days</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>A can complete the work in, 6 x 8 = 48 hour
</p><p>B can complete the same work in = 4 x 6 = 24 hours
</p><p>A's one hour work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q11.png" alt="Apti Time and Work"/></p>
<p>B's one hour work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q11_2.png" alt="Apti Time and Work"/></p>
<p>(A +B)'s one hour work = <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q11_3.png" alt="Apti Time and Work"/></p>
<p>They will complete <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q11_4.png" alt="Apti Time and Work"/></p>
<p>So, the entire work will be completed in 1 ∗ <u>144</u> <sub>=</sub> <u>144</u> hours<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9</p>
<p>Both work 8 hours a day so the number of days required to complete the work = <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q11_5.png" alt="Apti Time and Work"/> = 2 days</p>
</div> </Collapsible>
<br />

<p class="pq">12) A can finish a work in 6 days and B can finish the same work in 8 days. A and B charge Rs. 2800 for the work. If with the help of C they complete the work in 3 days, how much they will pay to C?</p>
<ol class="pointsu">
<li className='list'>Rs. 350</li>                                                            
<li className='list'>Rs. 345</li> 
<li className='list'>Rs. 340</li>                                                            
<li className='list'>Rs. 320</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's one hour work = <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6</p>
<p>B's one hour work = <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8</p>
<p>(A +B)'s one hour work = <u>1</u> <sub>+</sub> <u>1</u> <sub>=</sub> <u>7</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6&nbsp;&nbsp;&nbsp;&nbsp;8&nbsp;&nbsp;&nbsp;24</p>
<p>(A+B+C)'s one day work = <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3</p>
<p>Therefore, C's one day work = <u>1</u> <sub>-</sub> <u>7</u> <sub>=</sub> <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3&nbsp;&nbsp;&nbsp;&nbsp;24&nbsp;&nbsp;&nbsp;24</p>
<p>The ratio of A, B and C's wages will be equal to the ratio of work done by them in one day.</p>
<p>A's wages: B's wages: C's wages = <u>1</u> <sub>:</sub> <u>1</u> <sub>:</sub> <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6&nbsp;&nbsp;&nbsp;&nbsp;8&nbsp;&nbsp;24
</p><p>C's share of three days = 3 * C's share for one day</p>
= 3 ∗ (<u>1</u> ∗ 2800) = 350<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;24
</div> </Collapsible>
<br />

<p class="pq">13) 5 men undertook a piece of work and finished half the work in 18 days if two men drop out, in how many days the remaining work will be completed?</p>
<ol class="pointsu">
<li className='list'>30 days</li>                                             
<li className='list'>32 days</li>
<li className='list'>34 days</li>                                             
<li className='list'>36 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)"  trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>5 men completed half of the work in 18 days so the entire work will be completed in 36 days.</p>
<p>5 men' one day work will be = <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13.png" alt="Apti Time and Work"/></p>
<p>One man's one day work =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13_2.png" alt="Apti Time and Work"/></p>
<p>Two men drop out, so the three men have to complete the remaining work.</p>
<p>Three men's one day work will be =<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13_3.png" alt="Apti Time and Work"/></p>
<p><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13_4.png" alt="Apti Time and Work"/>&nbsp;&nbsp;&nbsp;part of the work is completed by three men in one day</p>
<p>Therefore, the remaining <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13_5.png" alt="Apti Time and Work"/>part of the work will be completed in <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/time-and-work-apti-q13_6.png" alt="Apti Time and Work"/> = 30 Days.</p>
</div> </Collapsible>
<br />

<p class="pq">14) If 5 workers can paint a house in 9 days, in how many days 3 workers can complete the same task?</p>
<ol class="pointsu">
<li className='list'>13 days</li>                                           
<li className='list'>14 days</li>
<li className='list'>15 days</li>                                           
<li className='list'>16 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p> Using formula: M1D1W2 =M2D2W1</p>
<p>We have = 5∗9∗W2 = 3∗D2∗W1</p>
<p>W2 = W1 as the task is the same in both the cases, so the amount of work to be done would be the same.</p>
<p>Therefore, we have 5 ∗ 9 = 3 ∗ D2</p>
<p>45 = 3∗ D2</p>
<p>D2 <sub>=</sub> &nbsp;&nbsp;<u>45</u> &nbsp;&nbsp;<sub>=</sub> &nbsp;&nbsp;15days<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3</p>
</div> </Collapsible>
<br />

<p class="pq">15) A group of workers undertakes a task. They can complete the task in 30 days. If 5 of them did not turn for the work and the remaining workers complete the task in 40 days, find the original number of workers.</p>
<ol class="pointsu">
<li className='list'>25 days</li>                                            
<li className='list'>23 days</li> 
<li className='list'>21 days</li>                                             
<li className='list'>20 days</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p>
<p>Let the original number of workers = X</p> 
<p>X workers can complete the work in 30 days.  And (X - 50) complete the same task in 40 days.</p>
<p><strong>Apply formula:</strong>  M1D1W2 =M2D2W1 </p>
<p>W1=W2 as the task is the same in both the cases.</p> 
<p>Therefore, X * 30 = (X - 5) * 40</p>
<p>30 X = 40X - 200</p> 
<p>200 = 40X -30X</p>
<p>200 = 10 X</p>
<p>X <sub>=</sub> &nbsp;&nbsp;<u>200</u> &nbsp;&nbsp;<sub>=</sub> &nbsp;&nbsp;20days<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10</p>
</div> </Collapsible>
<br />
<br/>


<p class="pq">16) 40 men can paint a building in 15 days working 4 hours a day. In how many days 30 men working 5 hours a day will complete the work?</p>
<ol class="pointsu">
<li className='list'>14 days</li>                                                      
<li className='list'>15 days</li> 
<li className='list'>16 days</li>                                                       
<li className='list'>17 days</li>                
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>Let the work will be completed in X days.</p>
<p><strong>Apply formula:</strong> M1 D1 T1 W2 = M2 D2 T2 W1</p>
<p>W1=W2 </p>
<p>Therefore, 40 * 15 * 4 = 30 * D2 * 5</p>
<p>2400 = 150 * D2</p>
<p>D2 = <u>2400</u> <sub>=</sub> 16days<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;150</p>
</div> </Collapsible> <br />
<p class="pq">17) A certain number of men can do a piece of work in 50 days. If there were 6 men more the same work could be done in 10 days less. Find the original number of men.</p>
<ol class="pointsu">
<li className='list'>21 men</li>                                                       
<li className='list'>22 men</li>
<li className='list'>23 men</li>                                                       
<li className='list'>24 men</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p>
<p>Let the original number of men = X</p>
<p>X men do the work in 50 days.</p>
<p>As per the question, X + 6 men can do the work in 40 days (50 -10).</p> 
<p><strong>Apply formula:</strong> M1D1W2 = M2D2W1</p>
<p>W1=W2</p>
<p>Therefore, X * 50 = (X + 6) * 40</p>
<p>50 X = 40X + 240</p>
<p>10X = 240</p>
<p>X = <u>240</u> <sub>=</sub> 24 men<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10</p>
</div> </Collapsible> <br />
<p class="pq">18) A is twice as good as workman as B so he can do a work in 40 days less than B. If they work together, in how many days they can do the work?</p>
<ol class="pointsu">
<li className='list'>80/4 days</li>
<li className='list'>80/5 days</li>
<li className='list'>80/3 days</li>
<li className='list'>80/6 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>A is twice as good as workman as B so he will take less time to do a piece of work than B and the ratio of time taken by A and B would be = 1:2</p>
<p>So, if there is a difference of one day (2-1), B takes 2 days.</p>
<p>As per question the difference in time taken by A and B is 40 days.</p>
<p>So, if the difference is of 40 days, B will take 2 * 40 = 80 days.</p>
<p>A takes 40 days less than B. So, A will take 40 days (80 - 40) to do the work.</p>
<p>A's one day work = <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;40</p>
<p>B's one day work = <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;80</p>
<p>(A + B)'s one day work =  <u>1</u> &nbsp;&nbsp; <sub>+</sub> &nbsp; <u>1</u> &nbsp; <sub>=</sub> &nbsp; <u>120</u> &nbsp; <sub>=</sub> &nbsp; <u>3</u><br/>
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;40&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;80&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3200&nbsp;&nbsp;&nbsp;&nbsp;80</p>
<p>So, working together they will do the work in <u>80</u> &nbsp;days <br/>
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3</p>
</div> </Collapsible> <br />
<p class="pq">19) A is twice as good as workman as B and working together they can do a piece of work in 20 days. If A alone works, in how many days he will do the work?</p>
<ol class="pointsu">
<li className='list'>30 days</li>                                              
<li className='list'>33 days</li>
<li className='list'>37 days</li>                                               
<li className='list'>40 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>As per question:</p>
<p>Work done by A in 1 day: work done by B in 1 day = 2:1</p>
<p>A and B working together can complete the work in 20 days.</p>
<p>So, (A+ B)'s one day work =  <u>1</u> <br/>
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20</p>
<p>Therefore, A's one day work will be  =  <u>1</u> &nbsp;&nbsp; <sub>∗</sub> &nbsp; <u>2</u> &nbsp; <sub>=</sub> &nbsp; <u>2</u> &nbsp; <sub>=</sub> &nbsp; <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;60&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;30</p>
<p>Therefore, A alone can finish the work in 30 days </p>
</div> </Collapsible> <br />
<p class="pq">20) 3 workers can do a piece of work in 20 days. If one of them works only for half time in a day, in how many days the work will be done?</p>
<ol class="pointsu">
<li className='list'>24 days</li>                                                            
<li className='list'>20 days</li>
<li className='list'>22 days</li>                                                            
<li className='list'>23 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>3 men's one day work = <u>1</u><br/>
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20</p>
<p>One man works for half day, so his one day's work = <u>1</u>  &nbsp;&nbsp; <sub>=</sub> &nbsp;&nbsp; <u>1</u><br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;60∗2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;120</p>
<p>Sum of each man one day's work = <u>1</u>  &nbsp;&nbsp; <sub>+</sub> &nbsp;&nbsp; <u>1</u> &nbsp;&nbsp;<sub>+</sub> &nbsp;&nbsp; <u>1</u> &nbsp;&nbsp; <sub>=</sub> &nbsp;&nbsp; <u>5</u> &nbsp;&nbsp;<sub>=</sub> &nbsp;&nbsp;<u>1</u><br/>
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;60&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;60&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;120&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;120&nbsp;&nbsp;&nbsp;&nbsp;24</p>
<p>Therefore, they will do the work in 24 days </p>
</div> </Collapsible>

<br />
<br/>



<p class="pq">21) A can finish the job at the same time in which B and C together do it. If A and B together can finish the work in 10 days and C alone can do the work in 50 days, how many days B will take to complete the same job?</p>
<ol class="pointsu">
<li className='list'>20 days</li> 
<li className='list'>22 days</li> 
<li className='list'>22(1/2) days</li> 
<li className='list'>25 days</li>                
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p><strong>ATQ,</strong></p>
<p>The efficiency of A = B+C<br/>
(A+B) can finish the work in 10 days, and C can finish the work in 50 days.</p>

<p>Now, A+B = 10 days<br/>
              C = 50 days</p>

<p><strong>Note: Assume the total work = LCM of the given days</strong></p>

<p>Take the LCM of days = LCM of (10 and 50) = 50<br/>
Let the total work = 50</p>
<p><strong>Note: One day work = (total work/ days)</strong></p>

<p><strong>Now, </strong></p>
<p>C's one day work = 50/50 = 1<br/>
(A+B)'s one day work = 5</p>

<p>i.e., (A+B+C)'s one day work = 5+1=6</p>

<p>i.e., A+A = 6<br/>
Or, A's one day work efficiency = 3</p>

<p>A+B = 5, i.e., 3+B = 5<br/>
Or, B's one day efficiency=2<br/>
Hence, B alone can work in 50/2 = 25 days</p>
</div> </Collapsible>
<br />

<p class="pq">22) A and B working together can finish a work in 12 days, B and C working together can finish the work in 16 days. If A works for 5 days, B works for 7 days, and C completes the remaining work in 13 days, C alone can complete the work in how many days? </p>
<ol class="pointsu">
<li className='list'>22 days </li>
<li className='list'>24 days</li>
<li className='list'>26 days</li>
<li className='list'>28 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>ATQ, </p>
<p>A+B = 12 days<br/>
B+C = 16 days</p>

<p><strong>Note: Assume the total work = LCM of the given days</strong></p>

<p>Take the LCM of days = LCM of (12 and 16) = 48<br/>
Let the total work = 48</p>
<p><strong>Note: One day work = (total work/ days)</strong></p>

<p>Now, </p>
<p>(A+B)'s one day work = 48/12 = 4 unit <br/>
(B+C)'s one day work = 48/16 = 3 unit</p>

<p>As per the question:</p>
<p>A works for 5 days<br/>
B works for 7 days or (5 + 2) days, that means B works 5 days with A and remaining 2 days with C.<br/>
C works 13 days or (2+11) days, that means C works 2 days with B and remaining 11 days alone.</p>

<p>That means total work done by (A+B) in 5 days <br/>
A+B = 5 days * 4 unit = 20 units <br/>
And, total work done by (B+C) = 2 days * 3 unit = 6 units<br/>
So, A+B+C finish the 26 units of work.</p>

<p>Remaining work = 48-26 = 22 unit work <br/>
And C completes the remaining work in 11 days.<br/>
i.e., C's one day's works = 22/11 = 2 units.</p>

<p>C alone can finish total work in [total work/ C's one day work] = [48/2] = 24 days.</p>
</div> </Collapsible>
<br />

<p class="pq">23) A can finish a work in 10 days and B can finish the same work in 15 days. If they work alternatively, find the time taken to finish the job. </p>
<ol class="pointsu">
<li className='list'>14 days</li>
<li className='list'>15 days</li>
<li className='list'>12 days</li>
<li className='list'>14.5 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given days</strong></p>

<p>Take the LCM of days = LCM of (10 and 15) = 30<br/>
Let the total work = 30</p>
<p><strong>Note: One day work = (total work/ days)</strong></p>

<p>Now, </p>
<p>A's one day work = 30/10 = 3 unit <br/>
B's one day work = 30/15 = 2 unit</p>

<p>That means A and B works 5 unit works in 2 days<br/>
i.e., 2 days = 5 unit work</p>

<p>To complete the 30 work, multiply both sides with 6.<br/>
i.e., 2 days * 6 = 5 unit work * 6</p>

<p>Or, 12 days = 30 works<br/>
So, A and B require 12 days to finish the work. </p>
</div> </Collapsible>
<br />

<p class="pq">24) A, B, and C individually can finish a job in 10, 15, and 30 days respectively. If A starts the work and continues until the end, B and C work alternatively, in how many days work will be done? </p>
<ol class="pointsu">
<li className='list'>6 days </li>
<li className='list'>4 days </li>
<li className='list'>4[1/3] days</li>
<li className='list'>6[3/5] days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given days</strong></p>

<p>Take the LCM of days = LCM of (10, 15, and 30) = 30<br/>
Let the total work = 30</p>

<p><strong>Note: One day work = (total work/ days)</strong></p>

<p>Now, </p>
<p>A's one day work = 30/10 = 3 unit <br/>
B's one day work = 30/15 = 2 unit<br/>
C's one day work = 30/30= 1 unit</p>

<p>ATQ, A work continuously and B and C works alternatively</p>

<p>i.e., (A+B)'s one day work = 3+2 = 5 unit<br/>
And (A+C)'s one day work = 3+1 = 4 unit</p>

<p>Or, 2 days work = 9 unit<br/>
To complete the 27 units work, multiply both sides with 3.</p>

<p>i.e., 2 days * 3 = 9 unit * 3<br/>
Or, 6 days = 27 units of work<br/>
Now, on the 7th day, the remaining work is done by A + B.<br/>
If (A+B)'s one day work = 5 unit work <br/>
i.e., <br/>
1 work = 1/5 days<br/>
Or, 3 work = 3/5 days</p>
<p>Hence, the work will be finished in 6+3/5 days or 6[3/5] days.</p>
</div> </Collapsible>
<br />

<p class="pq">25) A can finish a work in 10 days, B can finish the same work in 15 days, and C can finish it in 30 days. All three start working together, but after some days A leaves the job, then after one day B also left the job. C completes the remaining job in 3 days. Find the number of working days of B. </p>
<ol class="pointsu">
<li className='list'>4 days</li>
<li className='list'>5 days</li>
<li className='list'>6 days</li>
<li className='list'>7 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given days </strong></p>

<p>Take the LCM of days = LCM of (10, 15, and 30) = 30<br/>
Let the total work = 30</p>

<p><strong>Note: One day work = (total work/ days)</strong></p>

<p>Now, </p>
<p>A's one day work = 30/10 = 3 unit<br/> 
B's one day work = 30/15 = 2 unit<br/>
C's one day work = 30/30= 1 unit<br/>
Let A works for days = D<br/>
</p><p><strong>Note: man * days = total work</strong></p>

<p>ATQ, (A+B+C) works 6 units work per day till D days, so their total work = 6 * D<br/>
(B+C) works 3 unit work per day till 1 day, so their total work = 3 * 1 = 3 <br/>
C works 1 unit work per day till 3 days, so his total work = 1 * 3 = 3</p>

<p>Or, 6*D + 3*1 + 1*3 = 30 (total work)<br/>
6D = 30-6<br/>
D = 24/6<br/>
D= 4</p>
<p>So, A works for 4 days, B works for 4+1=5 days, and C works for 4+1+3= 8 days. </p>
</div> </Collapsible>
<br />

<br/>

 
<br />





<p class="pq">26) A can finish a work in 8 hours, B can finish the same work in 12 hours, and C can do it in 24 hours. All the three starts work at 3 am, 4 am, and 5 am respectively. At what time work will be completed?</p>
<ol class="pointsu">
<li className='list'>6 am</li>
<li className='list'>7: 40 am</li>
<li className='list'>8 am </li>
<li className='list'>5 am</li>                
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given time</strong> </p>

<p>Take the LCM of hours = LCM of (8, 12, and 24) = 24<br/>
Let the total work = 24 </p>

<p><strong>Note: One hour work = (total work/ time)</strong> </p>

<p><strong>Now,</strong>  </p>
<p>A's one hour work = 24/8 = 3 unit <br/>
B's one hour work = 24/12 = 2 unit<br/>
C's one hour work = 24/24= 1 unit </p>

<p><strong>ATQ,</strong> between 3 am - 4 am, A works alone and finish 3 units of work <br/>
Between 4 am - 5 am, A and B work and complete 3+2 = 5 units of work<br/>
Between 5 am - 6 am, A, B, and C works and finishes 3+2+1 = 6 units of work </p>

<p>Or, between 3 am to 5 am, 8 unit of work is finished. <br/>
Remaining 24-8= 16 unit (till 5am)<br/>
After 5 am, A+B+C work together and finish 6 unit of work per hours. </p>

<p>i.e., 6 unit work = 1 hour </p>

<p>To complete the 16 unit work, multiply both sides with 2 </p>

<p>i.e., 12 unit work = 2 hours<br/>
Remaining work = 16-12 = 4 unit work </p>

<p>As we know, 6 work = 1 hour<br/>
Or, 1 work = 1/6 hours<br/>
Or, 4 work = 4/6 or 2/3 hours. </p>

<p>That means (2 + 2/3) hours requires after 5 am. </p>
<p>So, time taken to complete the work is (5 +2 + 2/3) = 7:40am </p>
</div> </Collapsible>
<br />

<p class="pq">27) A and B work separately in 15 hours and 12 hours respectively. Another man C can destroy the work in 4 hours. If they start doing work at 8 am, 9 am, and 11 am respectively. At what time the total work will be destroyed?   </p>
<ol class="pointsu">
<li className='list'>11 am</li>
<li className='list'>12 pm</li>
<li className='list'>2:40 pm</li>
<li className='list'>3:20pm</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given time</strong></p>

<p>Take the LCM of hours = LCM of (15, 12, and 4) = 60<br/>
Let the total work = 60</p>

<p><strong>Note: One hour work = (total work/ time)</strong></p>

<p><strong>Now,</strong> </p>
<p>A's one hour work = 60/15 = 4 unit <br/>
B's one hour work = 60/12 = 5 unit<br/>
C's one hour work = 60/4= 15 unit</p>

<p><strong>ATQ,</strong> between 8 am - 9 am, A works alone and finish 4 units of work <br/>
Between 9 am - 10 am, A and B work and complete 4+5 = 9 units of work<br/>
Between 10 am - 11 am, A and B work and complete 4+5 = 9 units of work<br/>
Between 11 am - 12 am, A, B works, and C destroys it. i.e., 4+5 - 9 = - 6 unit of work<br/>
Where -ve indicates destroyed work <br/>
That means after 11 am, the net work is -6 per hour.<br/>
Total work till 11 am = 4+9+9= 22 unit</p>
 
<p>Destroy 6 unit works in 1 hour, or 1 unit work in 1/6 hours.<br/>
Time taken to destroy 22 unit works = 22/6 = 11/3 hours<br/>
Or, 3[2/3] hours</p>

<p>Hence, at 11am + 3[2/3] hours = 2:40 pm the total work will be destroyed. </p>
</div> </Collapsible>
<br />

<p class="pq">28) A can complete a wall in 30 hours. B uses 30 bricks per hour, and together they can finish the wall in 12 hours. How many bricks are in the wall? </p>
<ol class="pointsu">
<li className='list'>800 bricks</li>
<li className='list'>600 bricks</li>
<li className='list'>620 bricks</li>
<li className='list'>500 bricks</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given time</strong></p>

<p>Take the LCM of hours = LCM of (30 and 12) = 60<br/>
Let the total work = 60</p>
<p><strong>Note: One hour work = (total work/ time)</strong></p>

<p>A's one hour work = 60/30 = 2 unit <br/>
(A+B)'s one hour work = 60/12 = 5 unit<br/>
B's one hour work = 2+B = 5 units, or, B = 3 units </p>

<p>B alone can complete the work in 60/3 = 20 hours<br/>
And, B uses 30 bricks per hour.</p>
<p>Hence, total bricks in the wall = 20*30 = 600 bricks </p>
</div> </Collapsible>
<br />

<p class="pq">29) A and B can complete a wall in 15 and 20 hours respectively. If they work together, the wall is completed in 12 hours and they use 280 less bricks. Find the total number of bricks in the wall.  </p>
<ol class="pointsu">
<li className='list'>8400 bricks </li>
<li className='list'>16800 bricks</li>
<li className='list'>10000 bricks </li>
<li className='list'>12000 bricks</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: Assume the total work = LCM of the given time</strong></p>

<p>Take the LCM of hours = LCM of (15 and 20) = 60<br/>
Let the total bricks = 60</p>
<p><strong>Note: One hour work = (total work/ time)</strong></p>

<p>A's one hour work = 60/15 = 4 bricks <br/>
B's one hour work = 60/20 = 3 bricks</p>

<p>(A+B)'s one hour work = 4+3 = 7 bricks....................... (i)<br/>
But, ATQ<br/>
(A+B)'s one hour work = 60/12 = 5 bricks.................... (ii)</p>

<p>The difference between equation i and ii = 2 bricks/hour<br/>
But, ATQ it is 280 bricks <br/>
i.e., multiple of 140<br/>
So, multiply the total work with 140<br/>
Hence, 60* 140 = 8400 bricks</p>
</div> </Collapsible>
<br />

<p class="pq">30) The efficiency ratio of A, B, and C are 2:3:4. To finish a job A takes 10 days more than B, if they work together, the work will be completed in how many days? </p>
<ol class="pointsu">
<li className='list'>6[2/3] days</li>
<li className='list'>10 days</li>
<li className='list'>15 days</li>
<li className='list'>18 days</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note:<br/>
(i) Efficiency and time are inversely proportional to each other.<br/>
(ii) If 3 efficiencies are given, we have to calculate the time ratio and then reciprocate each efficiency and multiply with the LCM of given efficiencies.<br/>
(iii) Efficiency * total days = total work </strong></p>   

<p><strong>ATQ, </strong></p>
Efficiency of A: B: C =2: 3: 4 <br/>
Calculate the LCM of (2, 3, and 4) = 12<br/>
Now, reciprocate the efficiencies = ½: 1/3: ¼<br/>
Multiply each with 12 and we get time ratio<br/>
Time ratio of A: B: C = 12 *[1/2]: 12*[1/3]: 12*[1/4] = 6: 4: 3<p></p>

<p>The difference between A and B's time ratio = 2, but ATQ, it is 10 <br/>
i.e., to calculate the days multiply time ratio with 5, then we get 6*5: 4*5: 5*3<br/>
The ratio of days= 30: 20: 15<br/>
Total work = efficiency * days = 30 * 2= 60, or 20*3= 60, or 15*4= 60<br/>
If all three work together<br/>
i.e., (A+B+C)'s one day work = 2+3+4 = 9 <br/>
Or, days required = total work/ (A+B+C)'s one day work<br/>
Or, 60/9 = 20/3 = 6[2/3] days<br/>
Hence, 6[2/3] days are required to complete the work.</p>
</div> </Collapsible>
<br />
<br/>

 
<br />




 </td>
 
        </div>
    )
}

export default Iq2
